import { Link, useParams } from 'react-router-dom';
import informacionprogramasCursos from './data/informacionProgramasCursos';
import '../FormacionTecnica/FormacionTecnica.css';

const ProgramasCursos = () => {
    const { slug } = useParams();

    // Buscar por slug o slugAlt para compatibilidad de rutas
    const curso = informacionprogramasCursos.find(
        (item) => item.slug === slug || item.slugAlt === slug
    );

    if (!curso) {
        return (
            <main className="programa-detalle programa-no-encontrado">
                <h1>No encontramos este curso</h1>
                <p>El curso que buscas no está disponible o ha cambiado de enlace.</p>
                <Link className="programa-volver" to="/cursos">Volver a Cursos</Link>
            </main>
        );
    }

    return (
        <main className="programa-detalle">
            <div className="programa-detalle-breadcrumb">
                <Link to="/cursos">Cursos</Link>
                <span aria-hidden="true">/</span>
                <span>{curso.nombreCorto}</span>
            </div>

            <section className="programa-detalle-contenido">
                <div className="programa-detalle-copy">
                    <p className="programa-detalle-eyebrow">Curso de Formación</p>
                    <h1>{curso.titulo}</h1>
                    <p className="programa-detalle-texto">
                        Capacítate en el curso de {curso.nombreCorto.toLowerCase()} ofrecido por el Instituto de Educación de la Cruz Roja Colombiana Seccional Sucre.
                    </p>
                    <div className="programa-detalle-descuento" aria-label="Información de inscripción">
                        <strong>Certificado</strong>
                        <span>otorgado al finalizar el curso</span>
                    </div>
                    <a
                        className="programa-detalle-cta"
                        href={`https://wa.me/573127431631?text=${encodeURIComponent(`Hola, quiero información sobre el Curso de ${curso.titulo}.`)}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        Solicitar información
                    </a>
                    <p className="programa-detalle-contacto">312 743 1631 · Calle 38 No. 29-18, Carretera Troncal</p>
                </div>

                <img
                    className="programa-detalle-afiche"
                    src={curso.imagen}
                    alt={`Afiche del curso ${curso.titulo}`}
                    loading="lazy"
                    decoding="async"
                />
            </section>

            <section className="programa-detalle-informacion" aria-label={`Información del curso ${curso.titulo}`}>
                <div className="programa-detalle-informacion-grid">
                    {curso.informacion.map((bloque) => (
                        <article className="programa-info-card" key={bloque.titulo}>
                            <div className="programa-info-card-titulo">
                                <span className="programa-info-icono" aria-hidden="true">{bloque.icono}</span>
                                <h3>{bloque.titulo}</h3>
                            </div>
                            {bloque.texto ? (
                                <p>{bloque.texto}</p>
                            ) : (
                                <ul>
                                    {bloque.elementos.map((elemento) => (
                                        <li key={elemento}>{elemento}</li>
                                    ))}
                                </ul>
                            )}
                        </article>
                    ))}
                </div>
            </section>

            {curso.conoceMas && (
                <section className="programa-conoce-mas" aria-labelledby="programa-conoce-mas-titulo">
                    <div className="programa-conoce-mas-marca" aria-hidden="true">+</div>
                    <div>
                        <h2 id="programa-conoce-mas-titulo">Conoce más:</h2>
                        <p className="programa-conoce-mas-texto">{curso.conoceMas}</p>
                    </div>
                </section>
            )}

            <Link className="programa-volver" to="/cursos">← Ver todos los cursos</Link>
        </main>
    );
};

export default ProgramasCursos;
